import { Link } from "react-router-dom";
import { ChevronRight, Home as HomeIcon } from "lucide-react";

/**
 * Visible breadcrumb navigation. Pair this with `useSeo({ breadcrumbs })`
 * which emits the matching BreadcrumbList JSON-LD.
 *
 * items = [{ name, path }] — last item is rendered as current (non-linked).
 */
export const Breadcrumbs = ({ items = [] }) => {
    if (!items.length) return null;
    return (
        <nav
            aria-label="Breadcrumb"
            className="text-xs sm:text-sm text-slate-600"
            data-testid="breadcrumbs"
        >
            <ol className="flex flex-wrap items-center gap-1">
                <li className="flex items-center gap-1">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1 text-blue-900 hover:underline font-semibold"
                        data-testid="breadcrumb-home"
                    >
                        <HomeIcon className="h-3.5 w-3.5" /> Home
                    </Link>
                </li>
                {items.map((it, i) => {
                    const isLast = i === items.length - 1;
                    return (
                        <li key={i} className="flex items-center gap-1">
                            <ChevronRight className="h-3.5 w-3.5 text-slate-400" />
                            {isLast ? (
                                <span
                                    className="text-slate-700 font-medium"
                                    aria-current="page"
                                    data-testid={`breadcrumb-current`}
                                >
                                    {it.name}
                                </span>
                            ) : (
                                <Link
                                    to={it.path}
                                    className="text-blue-900 hover:underline"
                                >
                                    {it.name}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};
